module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"street":"Straße","housenumber":"Hausnummer","zip":"PLZ","location":"Ort","country":"Land","tel":"Telefon","email":"Email","homepage":"Homepage"},"en":{"street":"Street","housenumber":"HouseNo","zip":"ZIP","location":"Location","country":"Country","tel":"Phone","email":"Email","homepage":"Homepage"}}')
  delete Component.options._Ctor
}
